import { useThemeStore } from '@/stores/theme';

export default defineNuxtPlugin((nuxtApp) => {
  const theme = useThemeStore();

  const changeTheme = (name: string) => {
    const vuetify = nuxtApp.vueApp.config.globalProperties.$vuetify;
    if (!vuetify?.theme) return;
    if (typeof vuetify.theme.change === 'function') {
      vuetify.theme.change(name);
    } else {
      (vuetify.theme.global.name as unknown as { value: string }).value = name;
    }
  };

  nuxtApp.hook('app:created', () => {
    changeTheme(theme.resolved);
  });

  if (import.meta.client) {
    watch(
      () => theme.resolved,
      (next) => {
        changeTheme(next);
      },
    );
  }
});
